import classNames from "classnames";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import ReactDropdown, {
  DropdownOption,
} from "./components/common/ReactDropdown";
import FinalizeProjectsPage from "./components/FinalizeProjectsPage";
import ImportCustomersPage from "./components/ImportCustomersPage";
import PlannerFilters, { CustomerData } from "./components/PlannerFilters";
import ImportArticlesPage from "./components/ImportArticlesPage";
import { default as FortnoxImportPage } from "./components/fortnox/ImportPage";
import FortnoxInvoiceCreatorPage from "./components/FortnoxInvoiceCreatorPage";

export function RenderPlannerFilters(container: Element, filterData: any) {
  const root = ReactDOM.createRoot(container);
  root.render(<PlannerFilters data={filterData} />);
}

export function RenderFinalizeProjectsPage(container: Element, data: any) {
  const root = ReactDOM.createRoot(container);
  root.render(<FinalizeProjectsPage data={data} />);
}

export function RenderReactDropdown(
  container: Element,
  placeholder: string | undefined,
  options: DropdownOption[],
  inputElementId: string,
  inputElementName: string,
  selectedValue: string | null,
  hasError: boolean,
  onChangeCode?: string,
  slim?: boolean
) {
  const onChange = () => {
    if (onChangeCode != null) {
      // This callback is called before the html is updated, so we wait one "cycle" before running code that doesn't know about react
      setTimeout(() => eval(onChangeCode), 0);
    }
  };

  const root = ReactDOM.createRoot(container);
  root.render(
    <ReactDropdown
      options={options}
      placeholder={placeholder}
      inputElementId={inputElementId}
      inputElementName={inputElementName}
      initialValue={selectedValue}
      isClearable={true}
      inputClassName={classNames(hasError && "input-validation-error")}
      onChange={onChange}
      slim={slim}
    />
  );
}

export function RenderImportCustomersPage(container: Element, urls: any) {
  const root = ReactDOM.createRoot(container);
  root.render(<ImportCustomersPage urls={urls} />);
}

export function RenderImportArticlesPage(
  container: Element,
  urls: any,
  companyTypes: any
) {
  const root = ReactDOM.createRoot(container);
  root.render(<ImportArticlesPage urls={urls} companyTypes={companyTypes} />);
}

export function RenderFortnoxImportPage(
  container: Element,
  singularName: string,
  pluralName: string,
  apiEndpoint: string
) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <FortnoxImportPage
      singularName={singularName}
      pluralName={pluralName}
      apiEndpoint={apiEndpoint}
    />
  );
}

export function RenderFortnoxInvoiceCreatorPage(
  container: Element,
  apiEndpoint: string,
  companyTypes: DropdownOption[],
  companies: DropdownOption[]
) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <FortnoxInvoiceCreatorPage
      apiEndpoint={apiEndpoint}
      companyTypes={companyTypes}
      companies={companies}
    />
  );
}
